<div class="text-white flex">
    <div class="cursor-pointer" (click)="selectLanguage(Language.DE)">DE</div>
    <div class="mx-2 border-0 border-l border-current border-solid"></div>
    <div class="cursor-pointer" (click)="selectLanguage(Language.EN)">EN</div>
</div>
